var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"ds-table-head-col",class:[
    _vm.align && ("ds-table-head-col-" + _vm.align)
]},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }